import type { Lang } from '../../lib/i18n';
import { plannerStrings } from '../../lib/tools';
import { eastVsWestBase } from '../../lib/events';
import { ToolLanding } from '../../components/tools/ToolLanding';
import { CompetitionPlanner, PLANNER_SLUG, PlannerView, exampleCompetitionPlan } from '../../components/tools/CompetitionPlanner';

export default function CompetitionPlannerPage({ lang = 'en' as Lang }: { lang?: Lang }) {
  const t = plannerStrings(lang);
  const example = exampleCompetitionPlan();
  return (
    <ToolLanding
      lang={lang}
      slug={PLANNER_SLUG}
      copy={t}
      embedHeight={1400}
      tool={<CompetitionPlanner lang={lang} />}
      extra={
        <section className="mb-14 card-chunky p-6 flex flex-col sm:flex-row sm:items-center gap-4" aria-labelledby="evw-heading">
          <span className="chip-icon w-12 h-12 text-2xl flex-shrink-0" aria-hidden="true">🏟️</span>
          <div className="flex-1 min-w-0">
            <h2 id="evw-heading" className="font-heading font-black text-ink text-lg">{t.events.heading}</h2>
            <p className="text-muted text-sm">{t.events.body}</p>
          </div>
          <a href={eastVsWestBase(lang)} className="btn-3d btn-3d--sm px-4 py-2 flex-shrink-0">{t.events.cta}</a>
        </section>
      }
      example={
        example && (
          <section className="mb-14" aria-labelledby="example-heading">
            <h2 id="example-heading" className="text-2xl md:text-3xl font-extrabold text-ink mb-2">{t.example.heading}</h2>
            <p className="text-muted mb-5">{t.example.intro}</p>
            <PlannerView plan={example} lang={lang} headingLevel="h3" />
          </section>
        )
      }
    />
  );
}
